import React from "react";
import "./DashboardCards.css";
import { TruckTick } from "../../images/Images";

interface DashboardCardProps {
  item: {
    title: string;
    value: number | string;
    img: any;
  };
}

const DashboardCard: React.FC<DashboardCardProps> = ({ item }) => {
  console.log(item);

  return (
    <div className="dashboard__card">
      <div className="dashboard__card__flex">
        <div className="dashboard__card__text">{item?.title}</div>
        <img src={item?.img} alt="" />
      </div>
      <div className="dashboard__card__figure">{item?.value}</div>
    </div>
  );
};

export default DashboardCard;
